"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewDerivateGantt = void 0;
const view_derivate_grid_1 = require("./view_derivate_grid");
// gantt is consistent with the data required by the Grid view.
class ViewDerivateGantt extends view_derivate_grid_1.ViewDerivateGrid {
    constructor(state, datasheetId) {
        super(state, datasheetId);
        this.state = state;
        this.datasheetId = datasheetId;
    }
}
exports.ViewDerivateGantt = ViewDerivateGantt;
//# sourceMappingURL=view_derivate_gantt.js.map